import React from 'react';
import '../../styles/CallToActionSection.css';

const CallToActionSection = ({ 
  title = "Are You Ready To Transform Your Body & Life?",
  subtitle = "Select the services you'd like help with to receive a free consultation",
  buttonText = "Book Your Free Session",
  onButtonClick = null,
  className = "",
  showContactModal = true
}) => {
  const handleButtonClick = () => {
    if (onButtonClick) {
      onButtonClick();
    } else if (showContactModal) {
      // Dispatch global event for navbar to handle
      window.dispatchEvent(new Event('openContactModal'));
    }
  };

  return (
    <section className={`cta-section ${className}`}>
      <div className="cta-section-container">
        <h2 className="cta-section-title">{title}</h2>
        <p className="cta-section-subtitle">{subtitle}</p>
        <button 
          className="cta-section-button"
          onClick={handleButtonClick}
        >
          {buttonText}
        </button>
      </div>
    </section>
  );
};

export default CallToActionSection;
